import React, { useRef, useState } from "react"
import types from "prop-types"
import clsx from "clsx"
import useResizeObserver from "@react-hook/resize-observer"
import Tooltip from "shared/Tooltip"

// Tailwind only generates classes written out in full, so breakpoint classes can't be built dynamically.
const TRUNCATE_CLASSES = {
  sm: "sm:truncate",
  md: "md:truncate",
  lg: "lg:truncate",
  xl: "xl:truncate",
  "2xl": "2xl:truncate",
}

const TruncatedWithTooltip = ({ text, className = "", truncateAt = undefined }) => {
  const ref = useRef(null)
  const [overflows, setOverflows] = useState(false)

  useResizeObserver(ref, (entry) => {
    setOverflows(entry.target.scrollWidth > entry.target.clientWidth)
  })

  const truncateClass = truncateAt ? TRUNCATE_CLASSES[truncateAt] : "truncate"

  return (
    <span ref={ref} className={clsx(truncateClass, className)}>
      {/* The trigger must match the visible width so the tooltip is positioned against the truncated text. */}
      <Tooltip text={overflows ? text : ""} triggerClassName="block truncate">{text}</Tooltip>
    </span>
  )
}

TruncatedWithTooltip.propTypes = {
  text: types.string.isRequired,
  className: types.string,
  truncateAt: types.oneOf(Object.keys(TRUNCATE_CLASSES)),
}

export default TruncatedWithTooltip
